import React, { Component } from 'react';
import { Upload, Modal, Icon, Button, Alert, Result } from 'antd';
import {
  Container,
  BulkUploadContainer,
  BulkUploadButton,
  UploadButtonWrapper,
  UploadListWrapper,
  FontUploadCards,
  BulkuploadErrorAlert, ColorLegend,
} from './styles';
import { uploadFonts } from '../../utils/services/uploadAPI';
import { withTranslation } from 'react-i18next';
import { BULK_FONT_UPLOAD_MODAL as trans } from './translationValues';

const NAMESPACES = ['BULK_FONT_UPLOAD_MODAL'];
const accept = '.ttf';
const acceptedExtension = ['ttf'];

class BulkFontUploadModal extends Component {
  constructor(props) {
    super(props);
    this.previousContext = null;
    this.state = {
      fileList: [],
      isAlertVisible: false,
      alertType: '',
      alertMessage: '',
      isUploadComplete: false,
      isUploadDisable: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!nextProps.visible) {
      return {
        isUploadDisable: false,
        isUploadComplete: false,
        alertType: '',
        alertMessage: '',
        isAlertVisible: false,
        fileList: []
      }
    }
    return null;
  }

  addFileToList = (file) => {
    this.setState({
      fileList: [...this.state.fileList, file]
    })
  }

  customRequest = async ({ file: requestFile, onSuccess, onError }) => {
    const { t } = this.props;
    let file = new File([requestFile], requestFile.name, { type: requestFile.type });
    file.uid = requestFile.uid;
    let fileExtension = requestFile.name.split('.')[file.name.split('.').length - 1].toLowerCase();
    let isValidFileExtension = acceptedExtension.some(data => {
      return data === fileExtension;
    });
    console.log({ file, fileExtension });
    if (!isValidFileExtension) {
      this.setState({
        alertMessage: t(trans.INVALID_FILE_ERROR_MESSAGE.key, trans.INVALID_FILE_ERROR_MESSAGE.value),
        isAlertVisible: true,
        alertType: 'error',
      });
      onError('invalid');
    } else {
      file.isLoading = false;
      file.status = 'done';
      this.addFileToList(file);
      onSuccess('ok');
    }
  };

  saveFonts = async () => {
    this.setState({ isUploadDisable: true, isAlertVisible: false });
    this.doNextFileUpload(0);
  };

  uploadAPIHandler = (delays, uploadedFonts) => {
    return new Promise(resolve => {
      setTimeout(async () => {
        console.log({ uploadedFonts });
        let response = await uploadFonts(uploadedFonts);
        if (response && response.errors && response.errors.length === 0) {
          resolve('success');
        } else {
          resolve('error');
        }
      }, delays);
    });
  };

  doNextFileUpload = startCount => {
    const { t } = this.props;
    let delays = 100;
    let filterFileList = this.state.fileList.filter(fileObj => {
      return fileObj.hasOwnProperty('status') && fileObj.status === 'done';
    });
    filterFileList[startCount].progress = 'loading';
    this.setState({ fileList: filterFileList });
    this.uploadAPIHandler(delays, filterFileList[startCount]).then(response => {
      if (response === 'success') {
        filterFileList[startCount].progress = 'success';
        this.setState({ fileList: filterFileList });
      } else {
        filterFileList[startCount].progress = 'error';
        this.setState({
          fileList: filterFileList,
          alertMessage: t(trans.UPLOAD_FAILED_ERROR_MESSAGE.key, trans.UPLOAD_FAILED_ERROR_MESSAGE.value),
          isAlertVisible: true,
          alertType: 'error',
        });
      }
      let count = startCount + 1;
      if (count < filterFileList.length) {
        this.doNextFileUpload(count);
        return false;
      } else {
        // Promise end  here
        let finalValidation = filterFileList.every(data => {
          return data.progress === 'success';
        });
        this.setState({
          isUploadComplete: finalValidation,
        });
        return false;
      }
    });
  };

  handleFileDelete = id => {
    let newFilterFileList = this.state.fileList.filter(element => {
      return element.uid !== id;
    });

    this.setState({
      fileList: newFilterFileList,
    });
  };

  handleModalClose = () => {
    this.setState({ fileList: [], isAlertVisible: false });
    this.state.isUploadComplete ? this.props.onSucess() : this.props.onCancel();
  };

  render() {
    const { visible, t } = this.props;
    let filterFileList = this.state.fileList.filter(fileObj => {
      return fileObj.hasOwnProperty('status');
    });
    const validCount = filterFileList.filter(file => file.status === 'done').length;
    return (
      <>
        <Container onKeyDown={e => e.stopPropagation()} style={{position: 'absolute'}}>
          <Modal
            centered
            maskClosable={false}
            visible={visible}
            width="1025px"
            onCancel={this.handleModalClose}
            footer={
              !this.state.isUploadComplete
                ? [
                    <Button key="back" onClick={this.handleModalClose}>
                      {t(trans.CANCEL_BUTTON.key, trans.CANCEL_BUTTON.value)}
                    </Button>,
                    <Button
                      key="submit"
                      type="primary"
                      onClick={this.saveFonts}
                      disabled={validCount < 1}
                    >
                      {t(trans.UPLOAD_BUTTON.key, trans.UPLOAD_BUTTON.value)} ({validCount})
                    </Button>,
                  ]
                : null
            }
            className="warning-modal"
          >
            {!this.state.isUploadComplete && (
              <BulkUploadContainer>
                <UploadButtonWrapper>
                  <Upload
                    multiple={true}
                    customRequest={this.customRequest}
                    showUploadList={false}
                    accept={accept}
                    disabled={this.state.isUploadDisable}
                  >
                    <BulkUploadButton initialUpload={filterFileList.length === 0 ? true : false}>
                      <div>
                        <Icon type="cloud-upload" />
                      </div>
                      <p>{t(trans.DRAG_AND_DROP_TEXT.key, trans.DRAG_AND_DROP_TEXT.value)}</p>
                    </BulkUploadButton>
                  </Upload>
                </UploadButtonWrapper>
                {validCount !== filterFileList.length && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <ColorLegend>{t(trans.UNRECOGNIZABLE_FILES_ERROR_MESSAGE.key, trans.UNRECOGNIZABLE_FILES_ERROR_MESSAGE.value)}</ColorLegend>
                  </div>
                )}
                <UploadListWrapper>
                  {filterFileList.map((file, index) => {
                    if (filterFileList.isLoading) {
                      return (
                        <FontUploadCards key={index}>
                          <Icon type="loading" />
                        </FontUploadCards>
                      );
                    }
                    return (
                      <FontUploadCards key={index} errorFile={file.progress === 'error' || file.status === 'invalid'}>
                        <div className="card-head">
                          <div>
                            <Icon type="font-size" />
                            <div className="card-text">
                              <span>{file.fontFamily || file.name} </span>
                              {file.fontVariant && <span>({file.fontVariant})</span>}
                            </div>
                          </div>
                          {(!file.progress || file.progress === 'error' || file.status === 'invalid') && (
                            <Icon className={'icon'} type="delete" onClick={() => this.handleFileDelete(file.uid)} />
                          )}
                          {file.progress === 'loading' && <Icon type="loading" />}
                          {file.progress === 'success' && (
                            <Icon
                              type="check-circle"
                              style={{ color: '#52c41a', fontSize: '20px' }}
                            />
                          )}
                        </div>
                      </FontUploadCards>
                    );
                  })}
                </UploadListWrapper>
                {this.state.isAlertVisible && this.state.alertMessage && (
                  <BulkuploadErrorAlert>
                    <Alert
                      message={this.state.alertMessage}
                      type={this.state.alertType}
                      closable
                      afterClose={() => this.setState({ alertMessage: '', alertType: '' })}
                    />
                  </BulkuploadErrorAlert>
                )}
              </BulkUploadContainer>
            )}
            {this.state.isUploadComplete && (
              <Result
                status="success"
                title={t(trans.UPLOAD_SUCCESS_MESSAGE.key, trans.UPLOAD_SUCCESS_MESSAGE.value)}
                extra={
                  <Button key="back" type="primary" onClick={() => this.props.onSucess()}>
                    {t(trans.BACK_BUTTON.key, trans.BACK_BUTTON.value)}
                  </Button>
                }
              />
            )}
          </Modal>
        </Container>
      </>
    );
  }
}

export default withTranslation(NAMESPACES)(BulkFontUploadModal);
